import React from "react";
import Header from "../common/header";
import CourseslistPage from "../layout/courses/courseslist-page";
import Footer from "../common/footer";

function CoursesList() {
    return (
        <div>
            <Header />
            <CourseslistPage />
            <Footer />
        </div>
    );
}

export default CoursesList;